import React from "react";
import moment from "moment-timezone";
import InfoInput from "./InfoInput";

const CarteiraDetalhes = ({
  carteira,
  handleInputChange,
  isAdmin,
  newArrayGestores,
  save,
  copyToClipboard,
  toggleSave,
  handleSave,
}) => {
  return (
    <div className="flex m-1 p-1 transition-height duration-300 justify-between">
      <div className="flex flex-col w-1/3">
        <textarea
          className="border-none rounded-md p-4 w-full h-1/2 resize-none"
          name="observacao"
          value={carteira.observacao}
          onChange={(e) => handleInputChange(e, carteira.id)}
        />
        <InfoInput
          name="telefone"
          id={carteira.id}
          value={carteira.telefone}
          onChange={handleInputChange}
          placeholder="TELEFONE"
          className="mt-1"
        />
        <InfoInput
          name="email"
          id={carteira.id}
          value={carteira.email}
          onChange={handleInputChange}
          placeholder="EMAIL"
        />
      </div>
      <div className="flex w-1/5 flex-col font-bold">
        <div className="flex flex-col items-start w-7/10">
          <h4 className="m-0 mb-1 text-base">Data Emissao</h4>
          <span>
            {moment(carteira.dataEmissao)
              .locale("pt-br")
              .format("HH:mm:ss DD/MM/YYYY")}
          </span>
        </div>
        <div className="mt-1 flex flex-col items-start">
          <h4 className="m-0 mb-0.5 text-base">Data Validade</h4>
          <span>
            {" "}
            <span>
              {moment.utc(carteira.dataValidade).format("DD/MM/YYYY")}
            </span>
          </span>
        </div>
      </div>
      <div className="flex flex-col w-1/5">
        {isAdmin && (
          <>
            <h4 className="my-0.5 text-base">Gestores:</h4>
            <select
              id="carteira_gestor"
              name="user_id"
              value={carteira.user_id}
              onChange={(e) => handleInputChange(e, carteira.id)}
              disabled={save === carteira.id ? false : true}
              className="border-none rounded-md bg-white font-bold p-1 w-auto"
            >
              {newArrayGestores.map((gestor) => (
                <option key={gestor.id} value={gestor.id}>
                  {" "}
                  {gestor.name}
                </option>
              ))}
            </select>
          </>
        )}
      </div>
      <div className="flex flex-col justify-around items-center w-1/6">
        <button
          className="bg-yellow-500 font-league-gothic text-lg border-none text-white w-full rounded-lg cursor-pointer"
          onClick={() => copyToClipboard(carteira.id)}
        >
          URL
        </button>
        {save === carteira.id ? (
          <button
            className="bg-green-600 transition-colors font-league-gothic text-lg border-none text-white w-full rounded-lg cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              handleSave(e, carteira.id);
            }}
          >
            SALVAR
          </button>
        ) : (
          <button
            className="bg-green-600 transition-colors font-league-gothic text-lg border-none text-white w-full rounded-lg cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              toggleSave(carteira.id);
            }}
          >
            EDITAR
          </button>
        )}
        <a
          className="text-center bg-indigo-800 no-underline font-league-gothic text-lg border-none text-white w-full rounded-lg"
          href={`/carteiras/${carteira.id}`}
          target="_blank"
          rel="noreferrer"
        >
          VISUALIZAR
        </a>
      </div>
    </div>
  );
};

export default CarteiraDetalhes;
